<template>
  <div>
    <el-form :inline="true" :model="q" size="mini">
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="q.time_range"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          :picker-options="pickerOptions"
          :clearable="false"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="所属商户:">
        <el-select v-model="q.source_platform_id" @change="changeMch(q.source_platform_id)" clearable placeholder="请选择">
          <el-option
            v-for="item in $store.state.user.userinfo.mchs"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="监控类型:">
        <el-select v-model="q.sensitive_type" clearable placeholder="请选择">
          <el-option v-for="(item,key) in sensitiveType" :key="key" :label="item" :value="key" />
        </el-select>
      </el-form-item>

      <el-form-item :label="label">
        <el-button type="text" v-if="dataStatus === 1" @click="changeStatus(2)">(点击切换）</el-button>
        <el-button type="text" v-if="dataStatus === 2" @click="changeStatus(1)">(点击切换）</el-button>
        <el-input v-if="dataStatus === 2" style="width: 180px" v-model="q.source_id" :disabled="!q.source_platform_id" :placeholder="placeholder" prefix-icon="el-icon-edit"></el-input>
        <el-select v-if="dataStatus === 1" v-model="q.agency_id" clearable filterable placeholder="请输入代理账号">
          <el-option v-for="item of AgencyList" :key="item.id" :label="item.id+'>'+item.user_name+'>'+item.nickname"
                     :value="item.id" ></el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="发送方ID:">-->
<!--        <el-input v-model="q.agency_id" placeholder="发送方ID" prefix-icon="el-icon-edit"></el-input>-->
<!--        &lt;!&ndash;<el-select v-model="q.source_platform_id" clearable placeholder="请选择">&ndash;&gt;-->
<!--        &lt;!&ndash;<el-option v-for="item in MerchantsList" :key="item.id" :label="item.name" :value="item.id"/>&ndash;&gt;-->
<!--        &lt;!&ndash;</el-select>&ndash;&gt;-->
<!--      </el-form-item>-->
      <el-form-item label="敏感词:">
        <el-input v-model="q.sensitive_word" placeholder="敏感词" prefix-icon="el-icon-edit"></el-input>
<!--        <el-select v-model="q.sensitive_word" allow-create default-first-option clearable filterable placeholder="请选择">-->
<!--          <el-option v-for="(val, key) in sitiveWordsList" :key="key" :label="val" :value="val" />-->
<!--        </el-select>-->
      </el-form-item>
      <el-form-item label="处理状态:">
        <el-select v-model="q.status" clearable placeholder="请选择">
          <el-option v-for="(item,key) in wordsTatus" :key="key" :label="item" :value="key" />
        </el-select>
      </el-form-item>
      <!--<el-form-item label="所属平台:">-->
      <!--<more-selete v-if="MerchantsList.length" :dataList="MerchantsList" showName="name" v-model="q.mch_ids" placeholder="请选择"></more-selete>-->
      <!--</el-form-item>-->
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="danger" @click="reload">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="listData.list"
      v-loading.body="listLoading"
      @sort-change="sortlist"
      size="mini"
      stripe
      border
      fit
      highlight-current-row
    >
      <el-table-column prop="id" label="ID" width="60" fixed="left"></el-table-column>
      <el-table-column prop="message_id" label="消息ID" width="120"></el-table-column>
      <el-table-column prop="sensitive_type" label="监控类型" width="120">
        <template slot-scope="scope">{{sensitiveType[scope.row.sensitive_type]}}</template>
      </el-table-column>
      <el-table-column prop="sensitive_words" label="敏感词" width="120"></el-table-column>
      <el-table-column prop="source_platform_id" label="所属商户" width="120">
        <template
          slot-scope="scope"
        >{{scope.row.from_agency?scope.row.target_user.platform.name:scope.row.source_user.platform.name}}</template>
        <!--<template slot-scope="scope" v-if="MerchantsList.find(item=>item.id==scope.row.source_platform_id)">{{MerchantsList.find(item=>item.id==scope.row.source_platform_id)['name'] }}</template>-->
      </el-table-column>
      <el-table-column prop="source_id" label="发送方" width="120">
        <template slot-scope="scope" v-if="scope.row.source_user">
          <span style="color: #080" v-if="scope.row.from_agency" >{{scope.row.source_user.nickname}}</span>
          <span v-else>{{scope.row.source_user.id}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="target_id" label="接收方" width="120">
        <template slot-scope="scope" v-if="scope.row.target_user">
          <span v-if="scope.row.from_agency">{{scope.row.target_user.id}}</span>
          <span v-else style="color: #080">{{scope.row.target_user.nickname}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="info" label="聊天详情" width="220">
        <template slot-scope="scope">
          <span v-html="formatterInfo(scope.row)"></span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="处理状态" width="120">
        <template slot-scope="scope">
          <span v-if="!scope.row.status">{{wordsTatus[scope.row.status]}}</span>
          <span v-else :style="{color: scope.row.status===1?'#080':'#f00'}">{{wordsTatus[scope.row.status]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="消息时间" sortable="custom" width="180"></el-table-column>
      <el-table-column prop="updated_at" label="最后更新时间" sortable="updated_at" width="180"></el-table-column>
      <el-table-column prop="desc" label="备注" width="200"></el-table-column>
      <el-table-column label="操作" width="210" fixed="right">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.status">
<!--              <el-button type="success" size="mini" @click="handleStatus(scope.row, 1)">通过</el-button>-->
              <el-button type="danger" size="mini" @click="handleStatus(scope.row, 0)">处理</el-button>
            </span>
            <el-button v-if="scope.row.status" type="primary" size="mini" @click="view(scope.row)">查看</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="q.page_no"
        :page-sizes="$store.state.app.pageSizeArr"
        :page-size="q.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listData.total"
      ></el-pagination>
    </div>
    <save-update
      v-if="showUpdate"
      :showUpdate.sync="showUpdate"
      :id="show_id"
      :Detail="Detail"
      :BulletinType="BulletinType"
      :MerchantsList="$store.state.user.userinfo.mchs"
    ></save-update>
    <service-iframe
      v-if="showServiceIframe"
      :showServiceIframe.sync="showServiceIframe"
      :ImInfo="ImInfo"
    ></service-iframe>
  </div>
</template>

<script>
import saveUpdate from "./saveUpdate";
import serviceIframe from "../Complaint/serviceIframe";
import { queryFilter } from "@/utils/patch";
import { getSensitiveTopicsList, putSensitiveTopics, getAgencyList, getSensitiveWordsList} from "@/api";
import { getQiuUrl } from "@/utils/config";
import timedate from "@/utils/timedate.js";

export default {
  components: { saveUpdate, serviceIframe },
  data() {
    return {
      listData: {},
      Detail: {},
      q: { page_size: 30, page_no: 1, time_range: [timedate.dateYesterdayStartHMS, timedate.dateTomorrowHMS ]},
      listLoading: false,
      showUpdate: false,
      showServiceIframe: false,
      settleCycle: this.$store.state.app.settleCycle,
      show_id: null,
      BulletinType: this.$store.state.app.BulletinType,
      sensitiveType: this.$store.state.app.sensitiveType,
      wordsTatus: this.$store.state.app.wordsTatus,
      MerchantsList: this.$store.state.user.userinfo.mchs,
      dataStatus: 1,
      label: '发送方代理',
      AgencyList: [],
      sitiveWordsList: {},
      status: [
        { label: "可用", text: true },
        { label: "不可用", text: false }
      ],
      ImInfo: {},
      topicId: 0,
      placeholder: '请先选择所属商户',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateTodayHMS,
                timedate.dateTodayHMS
              ]);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateYesterdayHMS,
                timedate.dateYesterdayHMS
              ]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateWeekHMS,
                timedate.dateTodayHMS
              ]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateOneMonthHMS,
                timedate.dateTodayHMS
              ]);
            }
          }
        ]
      }
      // mch_ids_Arr: null
    };
  },
  activated() {
    this.getList();
    this.getAgency();
    // this.getSensitiveWords();
  },
  deactivated() {
    this.listLoading = false;
  },
  methods: {
    changeMch(val) {
      this.placeholder = val ? '发送方用户ID' : '请先选择所属商户'
    },

    //获取敏感词
    getSensitiveWords() {
      getSensitiveWordsList({page_no: 1, page_size: 1000 }).then(res => {
        if (res.status===0){
          let Obj = {}
          res.data.items.map(item => {
            Obj[item.id] = item.content
          })
          this.sitiveWordsList = Obj
        }
      })
    },
    getAgency () {
      getAgencyList({agency_type: 1, page_size: 1000 }).then(res => {
        if (res.status === 0) {
          this.AgencyList = res.data.items
        }
      })
    },
    add() {
      this.show_id = null;
      this.showUpdate = true;
    },
    handleStatus(row, statu) {
      if (statu) {
        putSensitiveTopics(row.id, { status: 1 }).then(res => {
          if (res.status === 0) {
            this.$message({ type: "success", message: "启用成功!" });
            this.getList();
          }
        });
      } else {
        this.Detail = row;
        this.showUpdate = true;
      }
    },
    view(row) {
      this.show_id = row.id
      this.Detail = row;
      this.showUpdate = true;
    },
    changeStatus(status) {
      this.dataStatus = status
      this.$set(this.q, 'agency_id', '')
      this.$set(this.q, 'source_id', '')
      if (status===2){
        this.label = '发送方用户'
      }else {
        this.label = '发送方代理'
      }
    },
    showImInfo(row) {
      this.topicId = row.topic_id;
      this.ImInfo = row.from_agency
        ? {
            agency_id: row.source_user.id,
            mch_id: row.target_user.platform.id,
            user_id: row.target_user.id
          }
        : {
            agency_id: row.target_user.id,
            mch_id: row.source_user.platform.id,
            user_id: row.source_user.id
          };
      this.showServiceIframe = true;
    },
    query() {
      this.q = Object.assign(this.q, { page_no: 1, page_size: 30 });
      this.getList();
    },
    formatterInfo(row) {
      if (row.sensitive_type) {
        return row.info;
      } else {
        return (
          '<a href="' +
          getQiuUrl() +
          row.info +
          '" target="_blank" style="color: #080">【图片】</a>'
        );
      }
    },
    reload() {
      this.q = { page_size: 30, page_no: 1, time_range: [timedate.dateYesterdayStartHMS, timedate.dateTomorrowHMS ]};
      this.getList();
    },
    sortlist(sort) {
      this.q.$orderby = sort.prop;
      this.getList();
    },
    handleSizeChange(val) {
      this.q.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.q.page_no = val;
      this.getList();
    },
    getList() {
      const query = this.$dateFilter({
        data: this.q,
        range: "time_range",
        start: "start_created_at",
        end: "end_created_at"
      });
      getSensitiveTopicsList(queryFilter(query)).then(res => {
        if (res.status === 0) {
          this.listLoading = false;
          this.listData = res.data;
          res.data.items &&
            res.data.items.forEach((item, index) => {
              res.data.items[index].mchStr = [];
              item.mchs &&
                item.mchs.forEach(mch => {
                  res.data.items[index].mchStr.push(mch.name);
                });
              res.data.items[index].mchStr = res.data.items[
                index
              ].mchStr.toString();
            });
        }
      });
    }
  },
  watch: {
    showServiceIframe() {
      if (!this.showServiceIframe) {
        this.getList();
      }
    },
    showUpdate() {
      if (!this.showUpdate) {
        this.getList();
      }
    }
  }
};
</script>
